import '@/pages/dashboard/assets/scss/page/multiTimezone/components/Clock.scss';

import React, { useState, useRef, useEffect } from "react";
import moment from "moment";
import SingleClock from './canvasClock.js';
import BubbleEllipsis from "@/pages/dashboard/components/BubbleEllipsis";
import {getCountryFlag} from "@/pages/home/_config/countries";
import {timeZoneTransformForMoment} from "@/pages/dashboard/utils/utils";

import { styles } from '../_config/constant';


export default function Clock(props: any) {
  const { data } = props;
  const { area_code, time_zone, time_zone_show, show_icon, area_name } = data || {};
    
  return (
    <div className="clock dbd-timezone-clock">
      <ClockAndTime timeZone={time_zone} />
      <div className='clock-country'>
        {show_icon ? <img src={getCountryFlag(area_code)} className='clock-country-img' /> : ''}
        <BubbleEllipsis
          content={`${area_name} (${time_zone_show})`}
          maxWidth={show_icon ? 89 : 94}
          ellipsisContent={area_name}
        />
        <span className='clock-country-utc'>({time_zone_show})</span>
      </div>
    </div>
  );
}

/**
 * 时钟表盘和 日期时间 部分
 * 单独写一个组件是为了在 秒针转动过程中更新时间时 避免让国家时区文字部分也跟着重新渲染
 * @param props
 * @constructor
 */
function ClockAndTime({timeZone}: any) {
    
  const [time, setTime] = useState<any>();
  const ref = useRef(null);
  const styleRef = useRef({});
    
  useEffect(() => {
    const timeZoneMoment = timeZoneTransformForMoment(timeZone);
    const time = moment().utcOffset(timeZoneMoment);
    setTime(time);
    const clock = new SingleClock(ref.current);
    const style = getClockStyle(time.format('HH:mm:ss'));
    if (styleRef.current != style) {
      styleRef.current = style;
      clock.setOptions(style);
    }
    clock.show(time.format('HH:mm:ss'));
        
    const interval = setInterval(() => {
      const time = moment().utcOffset(timeZoneMoment);
      setTime(time);
      const style = getClockStyle(time.format('HH:mm:ss'));
      if (styleRef.current != style) {
        styleRef.current = style;
        clock.setOptions(style);
      }
      clock.show(time.format('HH:mm:ss'));
    }, 1000);
        
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (<>
    <canvas className='singleClock' ref={ref}></canvas>
    <div className='clock-date'>{time?.format('YYYY-MM-DD HH:mm:ss')}</div>
  </>);
}

// 在6点和18点之间，显示白色背景，否则显示黑色背景
function getClockStyle(time: string) {
  if (time >= '06:00:00' && time < '18:00:00') {
    return styles.white;
  }
  return styles.black;
}
